import { putApi } from "./api_instance";

export const acceptBid = async (bidId, dispatch) => {
  try {
    const { data } = await putApi({
      apiUrl: `/projects/api/myBids/approve-bid?bidId=${bidId}`,
      sendToken: true,
      dispatch,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
